export const BINANCE_CLIENT_ID = "39vZ9un1Fd";
export const BYBIT_CLIENT_ID = "3ccf41551815af4";

export const getOAuthRedirectUri = () => {
  const isProd = window.location.hostname.split(".")[0] === "my";
  return isProd
    ? "https://my.copyyy.it/signin"
    : "https://dev.copyyy.it/signin";
};

export const OAUTH_REDIRECT_URI = getOAuthRedirectUri();

export const normalizeExchange = (exchange) => {
  if (!exchange) return "Binance";
  const lower = exchange.toLowerCase();
  if (lower.includes("bybit")) return "ByBit";
  if (lower.includes("binance")) return "Binance";
  return exchange;
};

export const getOAuthCodeFromUrl = () =>
  new URLSearchParams(window.location.search).get("code");

/** Spot / futures / both — set before Quick Connect redirect. */
export const getStoredPermissionType = () => {
  const value = String(localStorage.getItem("permissionType") || "")
    .trim()
    .toLowerCase();
  if (value === "spot" || value === "futures" || value === "both") return value;
  return "both";
};

export const isOAuthReturnUrl = () =>
  new URLSearchParams(window.location.search).has("code");

export const isOAuthSigninReturnUrl = () => {
  const path = window.location.pathname;
  if (path !== "/signin" && path !== "/login") return false;
  return isOAuthReturnUrl();
};

export const isOAuthConnectCallback = () => {
  if (!isOAuthReturnUrl()) return false;
  const token = localStorage.getItem("token");
  const connectMode = localStorage.getItem("oauthConnectMode") === "connect";
  return Boolean(token || connectMode);
};

export const isOAuthConnectContext = () => {
  const hasOAuthCode = new URLSearchParams(window.location.search).has("code");
  const connectMode = localStorage.getItem("oauthConnectMode") === "connect";
  return hasOAuthCode || connectMode;
};

export const clearOAuthCodeFromUrl = () => {
  window.history.replaceState({}, "", window.location.pathname);
};

export const clearOAuthSessionState = () => {
  localStorage.removeItem("oauthConnectMode");
  localStorage.removeItem("oauthReturnTo");
  localStorage.removeItem("memberNoLinkOAuth");
};

export const prepareExchangeOAuthRedirect = (exchange, options = {}) => {
  const {
    permissionType,
    returnTo,
    allowSocialLogin = false,
    connectMode = false,
    memberNoLink = false,
  } = options;
  const normalized = normalizeExchange(exchange);

  localStorage.setItem("ExchangeClick", normalized);
  localStorage.setItem("oauthReturnTo", returnTo || window.location.pathname);

  if (permissionType !== undefined && permissionType !== null) {
    localStorage.setItem("permissionType", permissionType);
  }

  if (connectMode) {
    localStorage.setItem("oauthConnectMode", "connect");
  } else {
    localStorage.removeItem("oauthConnectMode");
  }

  if (allowSocialLogin) {
    localStorage.setItem("AllowSocialLogin", "true");
  }

  if (memberNoLink) {
    localStorage.setItem("memberNoLinkOAuth", "true");
  } else {
    localStorage.removeItem("memberNoLinkOAuth");
  }
};

export const buildBinanceOAuthUrl = () => {
  const params = new URLSearchParams({
    client_id: BINANCE_CLIENT_ID,
    redirect_uri: getOAuthRedirectUri(),
    response_type: "code",
    scope: "user:openId,create:apikey",
  });

  return `https://accounts.binance.com/en/oauth/authorize?${params.toString()}`;
};

export const buildBybitOAuthUrl = () => {
  const params = new URLSearchParams({
    client_id: BYBIT_CLIENT_ID,
    redirect_uri: getOAuthRedirectUri(),
    response_type: "code",
    scope: "openapi",
    state: "123abc",
  });

  return `https://www.bybit.com/oauth?${params.toString()}`;
};

export const redirectToBinanceOAuth = (options = {}) => {
  prepareExchangeOAuthRedirect("Binance", options);
  window.location.href = buildBinanceOAuthUrl();
};

export const redirectToBybitOAuth = (options = {}) => {
  prepareExchangeOAuthRedirect("ByBit", options);
  window.location.href = buildBybitOAuthUrl();
};
